import React from 'react';

export const Item = ({ src, alt }) => {
  return (
    <div className="our-partners_item">
      <img src={src} alt={alt} />
    </div>
  );
};
